var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.32 2.04l-8.37 6.23 1.55-3.68 6.82-2.55z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68 2.04l8.3 6.29-1.47-3.74-6.83-2.55z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 16.18l-2.23 3.41 4.77 1.31 1.37-4.65-3.91-.07z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68 16.25l1.36 4.65 4.76-1.31-2.22-3.41-3.9.07z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54 10.52L6.2 12.56l4.73.21-.17-5.08-3.22 2.83z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.46 10.52l-3.27-2.88-.11 5.13 4.72-.21-1.34-2.04z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 19.59l2.85-1.39-2.46-1.92-.39 3.31z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 18.2l2.86 1.39-.4-3.31-2.46 1.92z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.21 19.59l-2.86-1.39.23 1.87-.02.79 2.65-1.27z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 19.59l2.65 1.27-.02-.79.22-1.87-2.85 1.39z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.03l-2.37-.7 1.67-.77.7 1.47z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.03l.7-1.47 1.68.77-2.38.7z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 19.59l.41-3.41-2.63.07 2.22 3.34z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 16.18l.42 3.41 2.23-3.34-2.65-.07z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 12.56l-4.72.21.44 2.26.7-1.47 1.68.77 1.9-1.77z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13 14.33l1.67-.77.7 1.47.44-2.26-4.74-.21 1.93 1.77z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 12.56l2 3.89-.07-1.94-1.93-1.95z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 14.51l-.08 1.94 2.01-3.89-1.93 1.95z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94 12.77l-.44 2.26.55 2.83.12-3.73-.23-1.36z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 12.77l-.22 1.35.11 3.74.56-2.83-.45-2.26z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.52 15.03l-.56 2.83.4.28 2.46-1.92.08-1.94-2.38.75z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13 14.28l.07 1.94 2.46 1.92.4-.28-.55-2.83-2.38-.75z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.56 20.86l.02-.79-.21-.18H10.64l-.2.18.02.79-2.66-1.27.93.76 1.88 1.31h2.79l1.89-1.31.93-.76-2.66 1.27z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 18.2l-.4-.28h-2.32l-.4.28-.22 1.87.2-.18h2.73l.21.18-.22-1.87h.42z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.72 8.67l.71-3.44L21.32 2.04l-8.18 6.07 3.15 2.66 4.44 1.3 .98-1.14-.43-.31.68-.62-.52-.4.68-.52-.44-.34z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57 5.23l.72 3.44-.46.34.68.52-.52.4.68.62-.43.31.98 1.14 4.44-1.3 3.14-2.66L2.63 2.04 1.57 5.23z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73 12.07l-4.44-1.3 1.34 2.04-2.01 3.89 2.65-.04h3.91l-1.45-4.59z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71 10.77l-4.44 1.3-1.48 4.59h3.9l2.65.04-2-3.89 1.37-2.04z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 12.77l.28-4.91 1.28-3.47H9.36l1.28 3.47.28 4.91.11 1.37v3.72h2.33l.01-3.72.11-1.37h-.4z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.bdd8f50de35cd9f7379be995e7575132.svg";
export { ForwardRef as ReactComponent };